import React from 'react';
import PropTypes from 'prop-types';
import IgniteDataTable from '../../../common/datatable/index';
import {dateTimeFormatUK} from '../../../../utils/commonFunctions';

class PushNotificationsTable extends React.Component {
  state = {
    sortBy: undefined
  };


  render() {
    const {notifications, sort} = this.props;

    const columns = [
      {
        prop: 'title',
        title: 'Title',
      },
      {
        prop: 'content',
        title: 'Content'
      },
      {
        prop: 'push-at',
        title: 'Date/Time',
        headOnClick: sort,
        format: data => dateTimeFormatUK(data)
      },
      {
        prop: 'status',
        title: 'Status',
        headOnClick: sort,
        width: 100,
      },
      {
        prop: 'user-name',
        title: 'Sent by',
        headOnClick: sort,
      },
    ];

    return (
      <div>
        <IgniteDataTable data={notifications} columns={columns}/>
      </div>
    );
  }
}

PushNotificationsTable.propTypes = {
  notifications: PropTypes.array.isRequired,
};

export default PushNotificationsTable;



// WEBPACK FOOTER //
// ./src/components/admin/app/push-notifications/push-notifications-table.jsx